import { render, staticRenderFns } from "./digital-human-audio-preview.vue?vue&type=template&id=b80de928"
import script from "./digital-human-audio-preview.vue?vue&type=script&lang=js"
export * from "./digital-human-audio-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports